//Generate Button
import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/salaryhistory/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPenToSquare,
  faClockRotateLeft,
  faListAlt,
} from "@fortawesome/free-solid-svg-icons";
import Layouts from "../../layouts/layouts";
import SalaryDetailModal from "../../components/salaryhistory/Salary Details";
import Add_data_modal from "../../components/salaryhistory/update_data_modal";
import "./salaryhistory.css";
import * as XLSX from "xlsx";
import Switch from "react-switch";

export default function Salaryhistory() {
  const title = "Salary History Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);
  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [showAuditModal, setShowAuditModal] = useState(false);
  const [auditHistory, setAuditHistory] = useState([]);
  const [auditLoading, setAuditLoading] = useState(false);
  const [auditEmployee, setAuditEmployee] = useState(null);
  const [auditError, setAuditError] = useState("");
  const [update_modal_data, setUpdate_modal_data] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showSalaryDetailModal, setShowSalaryDetailModal] = useState(false);
  const [selectedSalary, setSelectedSalary] = useState(null);
  const [showDutyModal, setShowDutyModal] = useState(false);
  const [selectedDutyRow, setSelectedDutyRow] = useState(null);
  // Filter states
  const prevMonthDate = new Date();
  prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);

  const [filterYear, setFilterYear] = useState(prevMonthDate.getFullYear());
  const [filterMonth, setFilterMonth] = useState(prevMonthDate.getMonth() + 1);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const viewAuditHistory = async (salaryRow) => {
    // Use the unique ID of the selected salary record
    if (!salaryRow?._id) {
      Swal.fire("Error", "Salary record ID is missing.", "error");
      return;
    }

    setAuditEmployee(salaryRow);
    setAuditHistory([]);
    setAuditError("");
    setAuditLoading(true);
    setShowAuditModal(true);

    try {
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("Authentication token not found.");
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/salary-history/salary-history/${salaryRow._id}/audit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.data.success) {
        throw new Error(
          response.data.message || "Unable to fetch audit history.",
        );
      }

      setAuditHistory(
        Array.isArray(response.data.data) ? response.data.data : [],
      );
    } catch (error) {
      console.error("Error fetching salary audit history:", error);

      setAuditError(
        error.response?.data?.message ||
          error.message ||
          "Unable to load audit history.",
      );
    } finally {
      setAuditLoading(false);
    }
  };

  const columns = [
    {
      name: <b>Employee ID </b>,
      selector: (row) => row.id_employee || "-",
      sortable: true,
    },
    {
      name: <b>Name</b>,
      selector: (row) => row.id_user?.name || "-",
      sortable: true,
      minWidth: "150px",
    },

    {
      name: <b>Status</b>,

      selector: (row) => row.id_user?.status || "-",

      cell: (row) => {
        const status = row.id_user?.status || "-";
        const normalizedStatus = status.toLowerCase();

        return (
          <button
            type="button"
            className={`btn salary-status-btn ${
              normalizedStatus === "active"
                ? "btn-success"
                : normalizedStatus === "inactive"
                  ? "btn-danger"
                  : "btn-secondary"
            }`}
            disabled
          >
            {status}
          </button>
        );
      },

      sortable: true,
    },

    {
      name: <b>Contact</b>,
      selector: (row) => row.id_user?.phonenumber || "-",
      sortable: true,
      minWidth: "130px",
    },
    {
      name: <b>Account Number</b>,
      selector: (row) => row.id_user?.bank_details?.account_number || "-",
      sortable: true,
      minWidth: "170px",
    },
    // {
    //   name: <b>Staff Type</b>,
    //   selector: (row) => row.id_user?.id_generalStaffType?.name || "-",
    //   sortable: true,
    //   minWidth: "130px",
    // },
    {
      name: <b>Staff Type</b>,
      selector: (row) => row.id_user?.id_generalStaffType?.name || "-",
      sortable: true,
      minWidth: "130px",
    },
    {
      name: <b>User Source</b>,
      selector: (row) => row.id_user?.userSource || "-",
      sortable: true,
    },
    {
      name: <b>Third Party</b>,
      selector: (row) => row.id_user?.thirdPartyProvider || "-",
      sortable: true,
    },

    {
      id: "totalOrders",
      name: <b>Total Trips</b>,
      selector: (row) => Number(row.totalOrders || 0),
      sortable: true,
      minWidth: "110px",
    },

    {
      name: <b>Attendance Salary (₹)</b>,

      selector: (row) => Number(row.gross_salary || 0),

      cell: (row) => (
        <span>
          ₹
          {Number(row.gross_salary || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),

      sortable: true,
      minWidth: "155px",
    },

    {
      name: (
        <div
          style={{
            backgroundColor: "#4CAF50",
            color: "white",
            padding: "4px 8px",
            borderRadius: "6px",
            display: "inline-block",
            fontWeight: 600,
          }}
        >
          Pay After Deductions
        </div>
      ),

      selector: (row) => Number(row.net_payable || 0),

      cell: (row) => (
        <span style={{ color: "#068525", fontWeight: 600 }}>
          ₹
          {Number(row.net_payable || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      ),

      sortable: true,
      minWidth: "155px",
    },

    {
      id: "actual_salary",
      name: (
        <div
          style={{
            backgroundColor: "#4CAF50",
            color: "white",
            padding: "4px 8px",
            borderRadius: "6px",
            display: "inline-block",
            fontWeight: 600,
          }}
        >
          Final Salary
        </div>
      ),
      selector: (row) => Number(row.actual_salary || 0),
      sortable: true,
      minWidth: "155px",
    },

    {
      id: "actual_pay",
      name: <b>Amount Paid (₹)</b>,
      selector: (row) =>
        row.actual_pay !== undefined && row.actual_pay !== null
          ? Number(row.actual_pay).toFixed(2)
          : "0.00",
      sortable: true,
      minWidth: "155px",
    },
    {
      id: "advanceMoney",
      name: (
        <div
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            padding: "4px 8px",
            borderRadius: "6px",
            fontWeight: 600,
          }}
        >
          Advance
        </div>
      ),
      selector: (row) => row.advanceMoney,
      sortable: true,
      cell: (row) => (
        <span style={{ color: "#1976d2", fontWeight: 600 }}>
          {row.advanceMoney}
        </span>
      ),
    },

    {
      id: "vehicleDamagePenalty",
      name: (
        <div
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            padding: "4px 8px",
            borderRadius: "6px",
            fontWeight: 600,
          }}
        >
          Damage
        </div>
      ),
      selector: (row) => row.vehicleDamagePenalty,
      sortable: true,
      cell: (row) => (
        <span style={{ color: "#1976d2", fontWeight: 600 }}>
          {row.vehicleDamagePenalty}
        </span>
      ),
    },

    {
      id: "cashSort",

      name: (
        <div
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            padding: "4px 8px",
            borderRadius: "6px",
            fontWeight: 600,
          }}
        >
          CashShort
        </div>
      ),
      selector: (row) => row.cashSort,
      sortable: true,
      cell: (row) => (
        <span style={{ color: "#1976d2", fontWeight: 600 }}>
          {row.cashSort}
        </span>
      ),
    },

    {
      id: "challanAmount",

      name: (
        <div
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            padding: "4px 8px",
            borderRadius: "6px",
            fontWeight: 600,
          }}
        >
          Challan Amount
        </div>
      ),
      selector: (row) => Number(row.challanAmount || 0),
      sortable: true,
      cell: (row) => (
        <span style={{ color: "#1976d2", fontWeight: 600 }}>
          ₹{Number(row.challanAmount || 0).toFixed(2)}
        </span>
      ),
    },

    {
      id: "routeabsentism",

      name: (
        <div
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            padding: "4px 8px",
            borderRadius: "6px",
            fontWeight: 600,
          }}
        >
          Route Absentism
        </div>
      ),
      selector: (row) => Number(row.routeabsentism || 0),
      sortable: true,
      cell: (row) => (
        <span style={{ color: "#1976d2", fontWeight: 600 }}>
          {Number(row.routeabsentism || 0).toFixed(2)}
        </span>
      ),
    },
    {
      id: "recoverablecod",

      name: (
        <div
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            padding: "4px 8px",
            borderRadius: "6px",
            fontWeight: 600,
          }}
        >
          Recover COD
        </div>
      ),
      selector: (row) => Number(row.recoverablecod || 0),
      sortable: true,
      cell: (row) => (
        <span style={{ color: "#1976d2", fontWeight: 600 }}>
          {Number(row.recoverablecod || 0).toFixed(2)}
        </span>
      ),
    },
    {
      id: "philfridge",

      name: (
        <div
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            padding: "4px 8px",
            borderRadius: "6px",
            fontWeight: 600,
          }}
        >
          Pilferage
        </div>
      ),
      selector: (row) => Number(row.philfridge || 0),
      sortable: true,
      cell: (row) => (
        <span style={{ color: "#1976d2", fontWeight: 600 }}>
          {Number(row.philfridge || 0).toFixed(2)}
        </span>
      ),
    },

    {
      name: (
        <div
          style={{
            backgroundColor: "#d32f2f",
            color: "white",
            padding: "4px 8px",
            borderRadius: "6px",
            fontWeight: 600,
          }}
        >
          Total Debit
        </div>
      ),
      selector: (row) => Number(row.deductions).toFixed(2),
      sortable: true,
      cell: (row) => (
        <span style={{ color: "#d32f2f", fontWeight: 700 }}>
          {Number(row.deductions).toFixed(2)}
        </span>
      ),
      minWidth: "140px",
    },

    {
      name: <b>Is Finalized</b>,
      cell: (row) => (
        <Switch
          onChange={() => handleToggle(row, "isFinalized")}
          checked={row.isFinalized}
          onColor="#4caf50"
          offColor="#ccc"
          uncheckedIcon={false}
          checkedIcon={false}
          height={20}
          width={40}
        />
      ),
      sortable: true,
    },
    {
      name: <b>Is Paid</b>,
      cell: (row) => (
        <Switch
          onChange={() => handleToggle(row, "isPaid")}
          checked={row.isPaid}
          onColor="#2196F3"
          offColor="#ccc"
          uncheckedIcon={false}
          checkedIcon={false}
          height={20}
          width={40}
        />
      ),
      sortable: true,
    },

    {
      name: <b>Created At</b>,
      selector: (row) => new Date(row.createdAt).toLocaleDateString("en-IN"),
      sortable: true,
    },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          {/* Edit */}
          <button
            type="button"
            onClick={() => setUpdateStoreBtn(row)}
            className="salary-action-btn edit-btn"
            title="Edit Salary"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>

          {/* View */}
          <button
            type="button"
            onClick={() => viewSalaryhistory(row)}
            className="salary-action-btn view-btn"
            title="View Salary History"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>

          {/* Audit History */}
          <button
            type="button"
            onClick={() => viewAuditHistory(row)}
            className="salary-action-btn audit-btn"
            title="View Audit History"
          >
            <FontAwesomeIcon icon={faClockRotateLeft} />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      minWidth: "155px",
    },
    {
      name: <b>Duty Breakdown</b>,
      cell: (row) => (
        <button
          type="button"
          className="duty-breakdown-btn"
          onClick={() => viewDutyBreakdown(row)}
          disabled={
            !row.clientWiseData?.some(
              (client) => client.dutyWiseData?.length > 0,
            )
          }
          title="View Duty-wise Salary Breakdown"
        >
          <FontAwesomeIcon icon={faListAlt} />
          <span>Duty Details</span>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      minWidth: "155px",
    },
  ];

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const handleToggle = async (row, field) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        Swal.fire("Unauthorized", "No token found", "error");
        return;
      }

      const updatedFieldValue = !row[field]; // toggle current value
      const payload = {
        [field]: updatedFieldValue,
      };

      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/api/v4/salary-history/salary-history/${row._id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        Swal.fire("Success", `${field} updated successfully.`, "success");
        // Refresh data after update
        fetchData(filterYear, filterMonth);
      } else {
        Swal.fire(
          "Error",
          response.data.message || "Failed to update",
          "error",
        );
      }
    } catch (error) {
      console.error("Toggle update error:", error);
      Swal.fire("Error", "Something went wrong while updating", "error");
    }
  };

  //Previous Month data not Available then, show latest month data
  const fetchData = async (yearParam, monthParam) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const fetchSalary = async (year, month) => {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v4/salary-history/get-salary-history?year=${year}&month=${month}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );
        return response;
      };

      // Step 1: If no param, use previous month
      let year = yearParam;
      let month = monthParam;

      if (!year || !month) {
        const today = new Date();
        const prevMonthDate = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1,
        );
        year = prevMonthDate.getFullYear();
        month = prevMonthDate.getMonth() + 1;
      }

      // Step 2: Try initial fetch
      let response = await fetchSalary(year, month);

      if (
        response.data.success &&
        Array.isArray(response.data.message) &&
        response.data.message.length > 0
      ) {
        setApiState(response.data.message);
        setApiCol(columns);
        return;
      }

      // Step 3: Loop to find latest available month (frontend only)
      const today = new Date();
      for (let i = 0; i < 12; i++) {
        const tryDate = new Date(today.getFullYear(), today.getMonth() - i, 1);
        const tryYear = tryDate.getFullYear();
        const tryMonth = tryDate.getMonth() + 1;

        // Skip already tried month
        if (tryYear === year && tryMonth === month) continue;

        const tryResponse = await fetchSalary(tryYear, tryMonth);
        if (
          tryResponse.data.success &&
          Array.isArray(tryResponse.data.message) &&
          tryResponse.data.message.length > 0
        ) {
          setApiState(tryResponse.data.message);
          setApiCol(columns);

          Swal.fire({
            icon: "info",
            title: "Showing Latest Available Data",
            text: `No data for ${month}/${year}. Showing data for ${tryMonth}/${tryYear}`,
          });

          return;
        }
      }

      // Step 4: No data found at all
      Swal.fire({
        icon: "info",
        title: "No Data Found",
        text: `No salary data available for any recent months.`,
      });
    } catch (error) {
      console.log("Error fetching salary history:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while fetching data.",
      });
    }
  };

  useEffect(() => {
    fetchData(); // Initial load
  }, []);

  const viewSalaryhistory = (salaryhistory) => {
    setSelectedSalary(salaryhistory);
    setShowSalaryDetailModal(true);
  };
  const viewDutyBreakdown = (row) => {
    setSelectedDutyRow(row);
    setShowDutyModal(true);
  };
  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const updateSalary = (updatedSalary) => {
    setApiState((prev) =>
      prev.map((salary) =>
        salary._id === updatedSalary._id ? updatedSalary : salary,
      ),
    );
  };
  const exportToExcel = () => {
    const transformedData = apistate.map((entry) => ({
      "Employee ID": entry.id_employee,
      Name: entry.id_user?.name || "-",
      PhoneNumber: entry.id_user?.phonenumber || "-",
      Email: entry.id_user?.email || "-",
      " Account Number": entry.bank_details?.account_number || "-",
      " Bank Name": entry.bank_details?.bank_name || "-",
      " Branch Name": entry.bank_details?.branch_name || "-",
      "IFSC Code": entry.bank_details?.ifsc_code || "-",
      "Account Holder Name": entry.bank_details?.account_holder_name || "-",
      "User Source": entry.id_user?.userSource || "-",
      "Third Party Name": entry.id_user?.thirdPartyProvider || "-",
      " Staff Type": entry.id_user?.id_generalStaffType?.name || "-",
      " Clients": entry.id_user?.id_client?.name || "-",
      Month: entry.month,
      Year: entry.year,
      "Attendance Salary": entry.gross_salary,
      "Salary After Debit": entry.net_payable,
      " Actual Salary": entry.actual_salary,
      "Actual Paid Amount": entry.actual_pay,
      "Advance Taken": entry.advanceMoney,
      CashShort: entry.cashSort,
      "Route Absentism": entry.routeabsentism || 0,
      "Recoverable COD": entry.recoverablecod || 0,
      Pilferage: entry.philfridge || 0,
      "Challan Amount": Number(entry.challanAmount || 0),
      "Total Debit": entry.deductions,
      "Is Paid": entry.isPaid,
      "Paid Days": entry.paid_days,
      "Unpaid Leaves": entry.unpaid_leaves,
      "Absent Days": entry.absent_days,
      "Present Days": entry.present_days,
      "Working Days": entry.working_days,
      "Actual Working Days": entry.actual_working_days,
      Comments: entry.comments,
      Notes: entry.notes || "-",
      "Created At": formatDate(entry.createdAt),
      Finalized: entry.isFinalized ? "Yes" : "No",
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Salary History");
    XLSX.writeFile(workbook, "salary_history.xlsx");
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />

      <SalaryDetailModal
        show={showSalaryDetailModal}
        onHide={() => setShowSalaryDetailModal(false)}
        salaryhistory={selectedSalary}
      />
      {/* Duty-wise Salary Breakdown Modal */}
      {showDutyModal &&
        selectedDutyRow &&
        (() => {
          const clientData = selectedDutyRow.clientWiseData || [];

          const totalDutyWiseSalary = clientData.reduce(
            (total, client) =>
              total +
              (client.dutyWiseData || []).reduce(
                (sum, duty) => sum + (Number(duty.gross_salary) || 0),
                0,
              ),
            0,
          );

          const formatCurrency = (amount) =>
            `₹${(Number(amount) || 0).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`;

          return (
            <div className="duty-modal-overlay">
              <div className="duty-modal">
                {/* Header */}
                <div className="duty-modal-header">
                  <div>
                    <h5>Duty-wise Salary Breakdown</h5>
                    <p>
                      Employee: {selectedDutyRow.id_user?.name || "-"}
                      {" | "}
                      ID: {selectedDutyRow.id_employee || "-"}
                      {" | "}
                      {selectedDutyRow.month}/{selectedDutyRow.year}
                    </p>
                  </div>

                  <button
                    type="button"
                    className="duty-modal-close"
                    onClick={() => setShowDutyModal(false)}
                    aria-label="Close"
                  >
                    &times;
                  </button>
                </div>

                {/* Client breakdowns */}
                <div className="duty-modal-body">
                  {clientData.some(
                    (client) => client.dutyWiseData?.length > 0,
                  ) ? (
                    clientData.map((client, clientIndex) => {
                      const duties = client.dutyWiseData || [];

                      if (!duties.length) return null;

                      const clientDutyTotal = duties.reduce(
                        (sum, duty) => sum + (Number(duty.gross_salary) || 0),
                        0,
                      );

                      const clientName =
                        client.id_client?.name ||
                        client.id_client?.clientName ||
                        (client.id_client ? "Client" : "No Client Assigned");

                      const isUnassigned = !client.id_client;

                      return (
                        <div
                          key={client._id || `${clientName}-${clientIndex}`}
                          className={`duty-client-card ${
                            isUnassigned ? "unassigned" : ""
                          }`}
                        >
                          <div className="duty-client-header">
                            <div>
                              <h6>{clientName}</h6>
                              <span className="duty-client-caption">
                                Duty-wise salary details
                              </span>
                            </div>

                            <div className="duty-client-amount">
                              <span>Client Salary</span>
                              <strong>
                                {formatCurrency(client.gross_salary)}
                              </strong>
                            </div>
                          </div>

                          <div className="table-responsive">
                            <table className="duty-breakdown-table">
                              <thead>
                                <tr>
                                  <th>Duty Type</th>
                                  <th className="text-center">Count</th>
                                  <th className="text-end">Gross Salary</th>
                                </tr>
                              </thead>

                              <tbody>
                                {duties.map((duty, dutyIndex) => (
                                  <tr key={`${duty.dutyType}-${dutyIndex}`}>
                                    <td>
                                      <span
                                        className={`duty-type-badge duty-${String(
                                          duty.dutyType || "",
                                        )
                                          .toLowerCase()
                                          .replace(/[^a-z0-9]+/g, "-")}`}
                                      >
                                        {duty.dutyType || "-"}
                                      </span>
                                    </td>

                                    <td className="text-center">
                                      {Number(duty.count) || 0}
                                    </td>

                                    <td className="text-end duty-amount">
                                      {formatCurrency(duty.gross_salary)}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>

                              <tfoot>
                                <tr>
                                  <td colSpan="2">Total Duty-wise Salary</td>
                                  <td className="text-end">
                                    {formatCurrency(clientDutyTotal)}
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="duty-empty-state">
                      No duty-wise salary details are available.
                    </div>
                  )}
                </div>

                {/* Grand total */}
                <div className="duty-modal-footer">
                  <div className="duty-grand-total">
                    <span>Total Duty-wise Salary</span>
                    <strong>{formatCurrency(totalDutyWiseSalary)}</strong>
                  </div>

                  <button
                    type="button"
                    className="duty-close-button"
                    onClick={() => setShowDutyModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          );
        })()}

      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateSalary={updateSalary}
      />

      {/* Salary Audit History Modal */}
      <div
        className={`modal fade ${showAuditModal ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
        aria-modal={showAuditModal ? "true" : undefined}
        style={{
          backgroundColor: showAuditModal
            ? "rgba(0, 0, 0, 0.5)"
            : "transparent",
        }}
      >
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content border-0 shadow">
            <div
              className="modal-header text-white"
              style={{ backgroundColor: "#4723d9" }}
            >
              <div>
                <h5 className="modal-title mb-1">
                  <FontAwesomeIcon icon={faClockRotateLeft} className="me-2" />
                  Salary Audit History
                </h5>
                <small>
                  {auditEmployee?.id_user?.name || "-"} | Employee ID:{" "}
                  {auditEmployee?.id_employee || "-"} | {auditEmployee?.month}/
                  {auditEmployee?.year}
                </small>
              </div>

              <button
                type="button"
                className="btn-close btn-close-white"
                aria-label="Close"
                onClick={() => setShowAuditModal(false)}
              />
            </div>

            <div className="modal-body">
              {auditLoading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status" />
                  <p className="mt-2 mb-0">Loading audit history...</p>
                </div>
              ) : auditError ? (
                <div className="alert alert-danger mb-0">{auditError}</div>
              ) : auditHistory.length === 0 ? (
                <div className="text-center text-muted py-5">
                  <FontAwesomeIcon
                    icon={faClockRotateLeft}
                    size="2x"
                    className="mb-3"
                  />
                  <p className="mb-0">
                    No audit history found for this salary record.
                  </p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered table-hover align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Field Changed</th>
                        <th>Old Value</th>
                        <th>New Value</th>
                        <th>Changed By</th>
                        <th>Role</th>
                        <th>Date & Time</th>
                      </tr>
                    </thead>

                    <tbody>
                      {auditHistory.map((item, index) => {
                        const changedByName =
                          item.changedBy?._id?.name ||
                          item.changedBy?.user_email ||
                          "-";

                        const oldValue =
                          item.oldValue === null || item.oldValue === undefined
                            ? "-"
                            : item.oldValue;

                        const newValue =
                          item.newValue === null || item.newValue === undefined
                            ? "-"
                            : item.newValue;

                        return (
                          <tr key={item._id}>
                            <td>{index + 1}</td>

                            <td>
                              <span className="badge bg-primary">
                                {String(item.field || "-")
                                  .replace(/([A-Z])/g, " $1")
                                  .replace(/^./, (char) => char.toUpperCase())}
                              </span>
                            </td>

                            <td>
                              <span className="text-danger fw-semibold">
                                {String(oldValue)}
                              </span>
                            </td>

                            <td>
                              <span className="text-success fw-semibold">
                                {String(newValue)}
                              </span>
                            </td>

                            <td>
                              <div className="fw-semibold">{changedByName}</div>
                              <small className="text-muted">
                                {item.changedBy?.user_email || ""}
                              </small>
                            </td>

                            <td>
                              <span className="badge bg-secondary">
                                {item.changedBy?.user_role || "-"}
                              </span>
                            </td>

                            <td style={{ minWidth: "165px" }}>
                              {item.createdAt
                                ? new Date(item.createdAt).toLocaleString(
                                    "en-IN",
                                    {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: true,
                                    },
                                  )
                                : "-"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="modal-footer">
              <span className="text-muted me-auto">
                Total changes: {auditHistory.length}
              </span>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowAuditModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="id_user.name"
                    apidata={apistate}
                    columns={apicol}
                    viewSalaryhistory={viewSalaryhistory}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
